import { useQuery } from "@tanstack/react-query";
import { getPlanRules } from "./services";

export const useGetPlanRulesQuery = (locale: string) =>
  useQuery({
    queryKey: ["planRules", locale],
    queryFn: () => getPlanRules(locale),
  });
